export const SET_VIDEO = 'VIDEO/SET_VIDEO'
export const SET_VIDEOS = 'VIDEO/SET_VIDEOS'
